import Hero, { HeroText, HeroIcon } from "../components/Hero";
import ProductBar, { Tab } from "../components/ProductBar";

import { Col } from "../components/Grid/";
import ContentBlock from "../components/ContentBlock";
import DividerImage from "../components/DividerImage";
import HtmlContainer from "../components/HtmlContainer";
import Image from "../components/Image";
import OrderButton from "../components/OrderButton";
import PricingContainer from "../components/PricingContainer";
import PropTypes from "prop-types";
import React from "react";
import TextSection from "../components/TextSection";
import injectSheet from "react-jss";
import HeroImg from "../img/Hero-scot.jpg";
import FirstSectionImage from "../img/Inbox-scot.jpg";
import SecondSectionImage from "../img/Phone-security.png";
import ThirdSectionImage from "../img/Statistics-scot.jpg";
import FourthSectionImage from "../img/Mailmerge-scot.jpg";
import FirstBackground from "../img/Background-scot-1.jpg";
import SecondBackground from "../img/Background-scot-2.jpg";
import ThirdBackground from "../img/Background-scot-3.jpg";
import FourthBackground from "../img/Background-scot-4.jpg";

const styles = theme => ({
  navcolour: {
    backgroundColor: theme.colours.products.scot
  },
  text: {
    width: "50vw",
    "@media (max-width: 823px)": {
      padding: 0,
      width: "90%"
    },
    "& h1": {
      fontSize: "5.4rem",
      margin: 0,
      textAlign: "center",
      "@media (max-width: 823px)": {
        fontSize: "3rem"
      }
    }
  },
  pricing: {
    marginBottom: "5rem",
    width: "35vw",
    "@media (max-width: 823px)": {
      marginBottom: "1rem",
      padding: 0,
      width: "90%"
    },
    "& h1": {
      fontSize: "5.4rem",
      margin: 0,
      textAlign: "center",
      "@media (max-width: 823px)": {
        fontSize: "3rem"
      }
    }
  },
  pricingContainer: {
    width: "100%"
  },
  contentBox: {
    minHeight: "100vh"
  },
  image: {
    width: "700px",
    "@media (max-width: 823px)": {
      display: "none"
    }
  },
  mobileImage: {
    width: "325px",
    "@media (min-width: 824px)": {
      display: "none"
    }
  }
});

const NavTabs = [
  {
    tabLink: "#features",
    tabName: "Features"
  },
  {
    tabLink: "#pricing",
    tabName: "Pricing"
  },
  {
    tabLink: "/tutorials",
    tabName: "Tutorials"
  },
  {
    tabLink: "/faq",
    tabName: "FAQ"
  },
  {
    tabLink: "/contact",
    tabName: "Support"
  }
];

const ScotPage = ({ classes, data }) => (
  <div>
    <ProductBar
      className={classes.navcolour}
      logoLink="/scot"
      logoSrc="/scot-logo.svg"
    >
      {NavTabs.map(tab => (
        <Tab key={tab.tabName} tabLink={tab.tabLink} tabName={tab.tabName} />
      ))}
    </ProductBar>
    <Hero hero={HeroImg} withBar>
      <div className={classes.heroTextContainer}>
        <HeroText>
          <HeroIcon src="/scottish-parliament.svg" />
          <HtmlContainer content={data.HeroText.html} />
        </HeroText>
      </div>
    </Hero>
    <ContentBlock className={classes.contentBox} id="features">
      <Col middle center>
        <TextSection className={classes.text}>
          <HtmlContainer content={data.FirstContentSection.html} />
        </TextSection>
        <Image image={FirstSectionImage} className={classes.image} />
        <Image image={FirstSectionImage} className={classes.mobileImage} />
      </Col>
    </ContentBlock>
    <DividerImage image={FirstBackground} />
    <ContentBlock className={classes.contentBox}>
      <Col middle center>
        <TextSection className={classes.text}>
          <HtmlContainer content={data.SecondContentSection.html} />
        </TextSection>
        <Image image={SecondSectionImage} className={classes.image} />
        <Image image={SecondSectionImage} className={classes.mobileImage} />
      </Col>
    </ContentBlock>
    <DividerImage image={SecondBackground} />
    <ContentBlock className={classes.contentBox}>
      <Col middle center>
        <TextSection className={classes.text}>
          <HtmlContainer content={data.ThirdContentSection.html} />
        </TextSection>
        <Image image={ThirdSectionImage} className={classes.image} />
        <Image image={ThirdSectionImage} className={classes.mobileImage} />
      </Col>
    </ContentBlock>
    <DividerImage image={ThirdBackground} />
    <ContentBlock className={classes.contentBox}>
      <Col middle center>
        <TextSection className={classes.text}>
          <HtmlContainer content={data.FourthContentSection.html} />
        </TextSection>
        <Image image={FourthSectionImage} className={classes.image} />
        <Image image={FourthSectionImage} className={classes.mobileImage} />
      </Col>
    </ContentBlock>
    <DividerImage image={FourthBackground} />
    <ContentBlock className={classes.contentBox} id="pricing">
      <div className={classes.pricingContainer}>
        <Col middle center>
          <TextSection className={classes.pricing}>
            <HtmlContainer content={data.PricingSection.html} />
          </TextSection>
        </Col>
        <PricingContainer>
          <HtmlContainer content={data.FirstPricingChecklist.html} />
          <HtmlContainer content={data.SecondPricingChecklist.html} />
          <HtmlContainer content={data.ThirdPricingChecklist.html} />
        </PricingContainer>
        <Col middle center>
          <OrderButton
            eventlabel="Clicked Scot buy button"
            mailinfo="mailto:sales@electedtechnologies.com?subject=Caseworker.scot Sales Enquiry"
            label="Order Caseworker Now"
            phonenumber="0333 344 1225"
          />
        </Col>
      </div>
    </ContentBlock>
  </div>
);

ScotPage.propTypes = {
  classes: PropTypes.object,
  data: PropTypes.object
};

export default injectSheet(styles)(ScotPage);

/* global graphql */
export const ScotQuery = graphql`
  query ScotQuery {
    HeroText: markdownRemark(frontmatter: { title: { eq: "Scot-HeroText" } }) {
      html
      frontmatter {
        title
      }
    }
    FirstContentSection: markdownRemark(
      frontmatter: { name: { eq: "Scot-FirstSection" } }
    ) {
      html
      frontmatter {
        name
      }
    }
    SecondContentSection: markdownRemark(
      frontmatter: { name: { eq: "Scot-SecondSection" } }
    ) {
      html
      frontmatter {
        name
      }
    }
    ThirdContentSection: markdownRemark(
      frontmatter: { name: { eq: "Scot-ThirdSection" } }
    ) {
      html
      frontmatter {
        name
      }
    }
    FourthContentSection: markdownRemark(
      frontmatter: { name: { eq: "Scot-FourthSection" } }
    ) {
      html
      frontmatter {
        name
      }
    }
    PricingSection: markdownRemark(
      frontmatter: { name: { eq: "Scot-PricingParagraph" } }
    ) {
      html
      frontmatter {
        name
      }
    }
    FirstPricingChecklist: markdownRemark(
      frontmatter: { name: { eq: "Scot-PricingSetup" } }
    ) {
      html
      frontmatter {
        name
      }
    }
    SecondPricingChecklist: markdownRemark(
      frontmatter: { name: { eq: "Scot-PricingSubs" } }
    ) {
      html
      frontmatter {
        name
      }
    }
    ThirdPricingChecklist: markdownRemark(
      frontmatter: { name: { eq: "Scot-PricingData" } }
    ) {
      html
      frontmatter {
        name
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/scot.jsx